import { AxiosResponse } from 'axios';

import { api } from '../common/utils';

export const login = async (username: string, password: string): Promise<{ data: string }> => {
  const response = await api.post('/api/admin_token', { username, password });
  return response.data as { data: string };
};

export const resetPassword = (email: string): Promise<AxiosResponse> =>
  api.post('/password_reset/', { email });

export const updatePassword = (
  token: string | undefined,
  password: string
): Promise<AxiosResponse> => api.post('/password_reset/confirm/', { token, password });
